import styles from "./ProgressIndicator.module.css";

interface ProgressIndicatorProps {
  /** 1-based current step among the visible (non-confirmation) steps. */
  current: number;
  total: number;
  label?: string;
}

/**
 * Compact progress indicator: a "3 / 8" pill plus a segmented bar. Calm, not busy.
 */
export function ProgressIndicator({ current, total, label }: ProgressIndicatorProps) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;
  return (
    <div
      className={styles.wrap}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-label={label ?? `Step ${current} of ${total}`}
    >
      <span className={styles.pill}>
        <span className={styles.cur}>{current}</span>
        <span className={styles.sep}>/</span>
        <span className={styles.tot}>{total}</span>
      </span>
      <span className={styles.track} aria-hidden="true">
        <span className={styles.fill} style={{ width: `${pct}%` }} />
      </span>
    </div>
  );
}
